import React from 'react'
import HeroImageForms from '../../../components/Commons/Forms/Layout/HeroImageForms'
import FooterSuscription from '../../../components/Commons/Forms/Layout/FooterSuscription'
import RegisterSaveCampaign from './RegisterSaveCampaign'

const RegisterSaveCampaignResult = () => {
    return (
        <div className="home">
            <HeroImageForms>
                <RegisterSaveCampaign />
                <FooterSuscription />
            </HeroImageForms>
        </div>
    )
}

export default RegisterSaveCampaignResult
